import { render, staticRenderFns } from "./TableUndeliveredInvoices.vue?vue&type=template&id=f232bfb8&"
import script from "./TableUndeliveredInvoices.vue?vue&type=script&lang=js&"
export * from "./TableUndeliveredInvoices.vue?vue&type=script&lang=js&"
import style0 from "./TableUndeliveredInvoices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports